import React, { FC } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { CompanyEditorFieldProps } from "../../CompanyEditor.types";

import { Switch, FormControlLabel } from "@components/base";

const PremiumAccess: FC<CompanyEditorFieldProps> = ({ control }) => {
  const { t } = useTranslation();

  return (
    <Controller
      name="isPremiumActive"
      control={control}
      render={({ field: { onChange, value } }) => (
        <FormControlLabel
          onChange={(_, checked) => onChange(checked)}
          control={<Switch checked={value ?? false} />}
          label={t("admin.premiumAccess")}
        />
      )}
    />
  );
};

export default PremiumAccess;
